import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lat", "lng"]

  connect() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        this.handlePosition.bind(this),
        this.handleError.bind(this)
      )
    }
  }

  handlePosition(position) {
    const lat = position.coords.latitude
    const lng = position.coords.longitude
    
    document.cookie = `user_lat=${lat};path=/`
    document.cookie = `user_lng=${lng};path=/`
  }

  handleError(error) {
    console.log("Geolocation error:", error)
  }
}
